export const CONFI = {
    uri: 'https://smartbuyweb.azurewebsites.net'
    //uri: 'http://localhost:4000'
}